import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';
import { getClientId } from '../../helpers';
import { useStore } from '../../store';
import { trackMixPanel } from '../../services/mixpanel.service';
import { removeFromLocalStorage, removeFromSessionStorage } from '../../services/storage.service';
import { ResetSlicesForAccountSwitching } from '../../store/service';
import { useAdaService } from '../services/useAdaService';
import { DASHBOARD_MODAL_SHOWN_KEY } from '../../services/useGlobalModalsManager';

const { BASE, VERSION } = USER.CONTROLLERS.LOGOUT;
const {
  METHOD: { POST },
} = HOOKS_SETTINGS;

export const useLogoutQuery = ({
  customerId,
  onSuccess,
  stepToShow,
}: {
  customerId: string;
  onSuccess?: () => void;
  stepToShow?: number;
}) => {
  const { handleAdaLogout } = useAdaService();
  return useQuery(
    ['logout'],
    async () => {
      const clientId = getClientId() ?? '';
      if (!customerId || !clientId) {
        return '';
      }
      const { data } = await httpService({
        url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
        method: POST,
        data: {
          clientId,
        },
      });
      return data;
    },
    {
      enabled: false,
      onSuccess: async () => {
        localStorage.clear();
        ResetSlicesForAccountSwitching();
        removeFromSessionStorage('customerId');
        removeFromSessionStorage(DASHBOARD_MODAL_SHOWN_KEY);
        removeFromLocalStorage('authUserId');
        const { setCurrentPage } = useStore.getState();
        const { setSummary } = useStore.getState();
        setSummary({});
        await handleAdaLogout();
        trackMixPanel('Logout');
        setCurrentPage(stepToShow || 0);
        if (onSuccess) onSuccess();
      },
      onError: async (e: any) => {
        console.log('error,', e);
        await handleAdaLogout();
        removeFromSessionStorage('customerId');
        removeFromLocalStorage('authUserId');
      },
    },
  );
};
